import { Controller } from "@hotwired/stimulus"

export default class PendingFileDownloadController extends Controller{
  static values =  {
    url: String
  }

  connect(){
    const link = document.createElement('a');
    link.href = this.urlValue;
    link.click();
  }
}